import * as constants from './constants';

export const fetchFormStart = (formKey) => ({
  type: constants.FETCH_FORM_START,
  payload: { formKey },
});

export const fetchFormSuccess = (formKey, fields) => ({
  type: constants.FETCH_FORM_SUCCESS,
  payload: { formKey, fields },
});

export const fetchFormFailure = (formKey, error) => ({
  type: constants.FETCH_FORM_FAILURE,
  payload: { formKey, error },
});

export const clearForm = (formKey) => ({
  type: constants.CLEAR_FORM,
  payload: { formKey },
});

export const clearAllForms = () => ({
  type: constants.CLEAR_ALL_FORMS,
});
